<div style="width: 100%; height: 500px;">
  <canvas #chartElement></canvas>
</div>
